import { Card, Dropdown, FloatButton, Pagination, Tooltip } from 'antd'
import React from 'react'
import { DownOutlined, PlusOutlined, LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { formateDate } from 'src/components/helpers/formateDate';
import { deleteClientAbonement, getAbonementsClient } from 'src/store/Slices/ClientsSlice';
import SureModal from 'src/components/Modals/SureModal';
import { useState } from 'react';
import EditAbonement from '../Modals/EditAbonement';

const MobileClientsAbonements = ({
    getAbonementsClientList,
    getAbonementsClientListLoading,
    setIsOpenAddEditModal,
    setAbonementInfo,
    page,
    setPage,
    setPageSize,
    setTab,
    abonementInfo,
    clientInfo,
    mnemo
}) => {

    const dispatch = useDispatch()

    const [openDeliteAbonementModal, setOpenDeliteAbonementModal] = useState(false)
    const [isOpenAddEditModal, setIsOpenEditModal] = useState(false)


    const items = [
        {
            key: '1',
            label: 'Редактировать',
            onClick: () => { setIsOpenEditModal(true) },
            disabled : (!mnemo?.children?.find(el => el.name === 'Таблица абонементов')?.children.find(ele => ele.mnemo === 'updateBtn'))
        },
        {
            key: '3',
            label: 'Удалить',
            onClick: () => { setOpenDeliteAbonementModal(true) },
            disabled : (!mnemo?.children?.find(el => el.name === 'Таблица абонементов')?.children.find(ele => ele.mnemo === 'deleteBtn'))
        },
    ];

    const onClickYesDeleteAbonement = () => {
        dispatch(deleteClientAbonement({
            clientId: clientInfo.id,
            abonementClubId: abonementInfo.abonementClubId
        })).then(() => {
            dispatch(getAbonementsClient({ clientId: clientInfo.id }))
            setOpenDeliteAbonementModal(false)
        })
    }

    return (
        <>
            <SureModal
                visible={openDeliteAbonementModal}
                setVisible={setOpenDeliteAbonementModal}
                onClickYes={onClickYesDeleteAbonement}
            />
            <EditAbonement
                abonementModal={isOpenAddEditModal}
                setAbonementModal={setIsOpenEditModal}
                clientInfo={clientInfo}
                abonementInfo={abonementInfo}
            />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Pagination
                    defaultCurrent={page}
                    pageSize={20}
                    showSizeChanger={false}
                    current={page}
                    onChange={(page, pageSize) => {
                        dispatch(getAbonementsClient({
                            clientId: clientInfo.id,
                            count: pageSize,
                            offset: pageSize * (page - 1),
                        }))
                        setPage(page)
                        setPageSize(pageSize)
                    }}
                    total={getAbonementsClientList?.data?.value?.totalCount}
                    page={page}
                />
                {getAbonementsClientList?.data?.value?.rows.map(element => {
                    return (
                        <Card
                            loading={getAbonementsClientListLoading}
                            title={`Абонемент №: ${element.id}`}
                            extra={<Dropdown
                                menu={{
                                    items,
                                }}
                            >
                                <a onClick={() => {
                                    setAbonementInfo({
                                        ...element,
                                        abonementFrom: element.abonementFrom && formateDate(element.abonementFrom),
                                        abonementTo: element.abonementTo && formateDate(element.abonementTo)
                                    })
                                }} className="text-primary text-decoration-none">
                                    Действия <DownOutlined />
                                </a>
                            </Dropdown>}
                            style={{ width: 330, marginTop: 16 }}
                            key={element.id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div>№:</div>
                                    <div>Клуб:</div>
                                    <div>Абонемент:</div>
                                    <div>Абонемент С:</div>
                                    <div>Абонемент До:</div>
                                    <div>Заморожен До:</div>
                                    <div>Заморожен:</div>
                                    <div>Дней заморозки:</div>
                                </div>
                                <div>
                                    <div>{element?.id ? element?.id : '-'}</div>
                                    <div>{element?.clubName ? <Tooltip title={element?.clubName}>{element?.clubName.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.abonementName ? <Tooltip title={element?.abonementName}>{element?.abonementName.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.abonementFrom ? <Tooltip title={element?.abonementFrom}>{formateDate(element?.abonementFrom)}</Tooltip> : '-'}</div>
                                    <div>{element?.abonementTo ? <Tooltip title={element?.abonementTo}>{formateDate(element?.abonementTo)}</Tooltip> : '-'}</div>
                                    <div>{element?.frozenTo ? <Tooltip title={element?.frozenTo}>{formateDate(element?.frozenTo)}</Tooltip> : '-'}</div>
                                    <div>{element?.isFrozen ? 'Да' : 'Нет'}</div>
                                    <div>{element?.frostUse ? element?.frostUse : '-'}</div>
                                </div>
                            </div>
                        </Card>
                    )
                })}
                <FloatButton
                    disabled={(!mnemo?.children?.find(el => el.name === 'Таблица абонементов')?.children.find(ele => ele.mnemo === 'insertBtn'))}
                    style={{ right: 24 }}
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                        setIsOpenAddEditModal({ open: true, flag: 'add' })
                    }}
                />
                <FloatButton
                    style={{ left: 24 }}
                    type="primary"
                    icon={<LeftOutlined />}
                    onClick={() => { setTab('Клиенты') }}
                />
            </div>
        </>
    )
}

export default MobileClientsAbonements